module.exports = __webpack_public_path__ + "static/media/event4-home.c5f2d31d.jpg";